module.exports = __webpack_public_path__ + "media/custom/images/img31-a6edde04237f3290176e76c19dfeec66.png";